import React from "react";
import Axios from "axios";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import "./styles.scss";

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const formSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "¡Muy corto!")
    .max(50, "¡Muy largo!")
    .required("Campo obligatorio"),
  email: Yup.string().email("Email inválido"),
  phone: Yup.string()
    .matches(phoneRegExp, "Teléfono inválido")
    .required("Campo obligatorio"),
  message: Yup.string().min(2, "¡Muy corto!")
});

class ContactFooter extends React.Component {
  render() {
    const { id } = this.props;
    return (
      <section id={id} className="contact-footer">
        <div className="contact-footer__wrapper container">
          <div className="row">
            <div className="contact-footer__info col">
              <h2 className="subtitle">Contacto</h2>
              <h3 className="title">Comuníquese y realice su consulta.</h3>
              <div className="contact-footer__items">
                <div className="contact-footer__items__item">
                  <h4 className="title">Horarios de atención</h4>
                  <p className="text">
                    Lunea a Viernes de 7:00 a 12:30
                    <br />
                    y de 15:30 a 20:00
                    <br />
                    Sábados de 7:00 a 12:00
                  </p>
                </div>
                <div className="contact-footer__items__item">
                  <h4 className="title">Horarios de extracción</h4>
                  <p className="text">
                    Lunea a Viernes de 7:00 a 12:30
                    <br />
                    Sábados de 7:00 a 12:00
                  </p>
                </div>
                <div className="contact-footer__items__item">
                  <h4 className="title">Dirección</h4>
                  <p className="text">
                    Pueyrredón 367, Las Flores,
                    <br />
                    Buenos Aires, Argentina.
                  </p>
                </div>
                <div className="contact-footer__items__item">
                  <h4 className="title">Teléfonos</h4>
                  <p className="text">
                    Tel./Fax:{" "}
                    <a href="tel:02244-453064" className="text__link">
                      02244-453064
                    </a>
                  </p>
                  <p className="text">
                    WhatsApp:{" "}
                    <a href="tel:02244-507685" className="text__link">
                      02244-507685
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div className="col">
              <Formik
                initialValues={{
                  email: "",
                  phone: "",
                  name: "",
                  message: ""
                }}
                validationSchema={formSchema}
                onSubmit={(values, actions) => {
                  console.log(values, actions);
                  actions.setStatus({
                    success: "Enviando…",
                    css: "sending"
                  });
                  actions.setSubmitting(false);

                  Axios.post("https://formcarry.com/s/6FZTvfsR0vF", {
                    name: values.name,
                    email: values.email,
                    phone: values.phone,
                    message: values.message
                  })
                    .then(function (response) {
                      if (response.status === 200) {
                        actions.setStatus({
                          success: "¡Enviado!",
                          css: "success"
                        });
                        actions.setSubmitting(true);
                      } else {
                        actions.setStatus({
                          success: "Algo salió mal. Volvé a intentar",
                          css: "error"
                        });
                        actions.setSubmitting(false);
                      }
                    })
                    .catch(function (error) {
                      console.log(error);
                    });
                }}
                render={({ errors, status, touched, isSubmitting }) => (
                  <Form className="form">
                    <div className="form__input-wrapper">
                      <Field
                        type="name"
                        name="name"
                        placeholder="Nombre"
                        className="form__input"
                      />
                      {errors.name && touched.name ? (
                        <small className="form__error-message">{errors.name}</small>
                      ) : null}
                    </div>
                    <div className="form__input-wrapper">
                      <Field
                        type="email"
                        name="email"
                        placeholder="E-mail"
                        className="form__input"
                      />
                      {errors.email && touched.email ? (
                        <small className="form__error-message">{errors.email}</small>
                      ) : null}
                    </div>
                    <div className="form__input-wrapper">
                      <Field
                        type="phone"
                        name="phone"
                        placeholder="Teléfono"
                        className="form__input"
                      />
                      {errors.phone && touched.phone ? (
                        <small className="form__error-message">{errors.phone}</small>
                      ) : null}
                    </div>
                    <div className="form__input-wrapper">
                      <Field
                        component="textarea"
                        name="message"
                        placeholder="Consulta"
                        className="form__input form__input--textarea"
                      />
                      {errors.message && touched.message ? (
                        <small className="form__error-message">{errors.message}</small>
                      ) : null}
                    </div>
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className={`form__submit ${status ? status.css : ""}`}
                    >
                      {status ? status.success : "Enviar"}
                      {console.log(status)}
                    </button>
                  </Form>
                )}
              />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ContactFooter;
